import React, { useState } from 'react';
import { Eye, EyeOff, Fingerprint, Loader2, Lock, User } from 'lucide-react';
import { Button } from '../../Button';
import { Input } from '../../Input';
import { DmpLogo } from '../../brand/DmpLogo';
import type { MobileNav } from '../../../types/mobile';
export function LoginScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const [userId, setUserId] = useState('BP-2587');
  const [password, setPassword] = useState('dmp@2587');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const submit = (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!userId || !password) {
      setError('বিপি/ইউজার আইডি ও পাসওয়ার্ড প্রদান করুন');
      return;
    }
    setError('');
    setLoading(true);
    window.setTimeout(() => {
      setLoading(false);
      nav.reset('home');
    }, 900);
  };
  return <div className="flex h-full flex-col bg-white" data-id="element-405" data-mp="3m1ljksa64zto">
      <div className="flex flex-col items-center bg-navy-800 px-6 pb-10 pt-8 text-white" data-id="element-406" data-mp="3lypnl9hvsl7v">
        <DmpLogo size={68} data-id="element-407" data-mp="23xrj9rgsojqz" />
        <p className="mt-3 text-sm font-semibold" data-id="element-408" data-mp="27x0c8u40gdlh">ঢাকা মেট্রোপলিটন পুলিশ</p>
        <p className="text-xs text-navy-200" data-id="element-409" data-mp="27zcu779rqnyj">সিএনজি ও চালক যাচাই ব্যবস্থা</p>
      </div>
      <form onSubmit={submit} className="-mt-6 flex-1 rounded-t-2xl bg-white px-5 pt-6" data-id="element-410" data-mp="2cv1ujctm48vw">
        <h1 className="font-heading text-xl font-bold text-navy-900" data-id="element-411" data-mp="2hx0vyh5skvq7">লগইন</h1>
        <p className="mb-5 text-xs text-slate-500" data-id="element-412" data-mp="2mthp5prum0a5">আপনার অফিসিয়াল তথ্য দিয়ে প্রবেশ করুন</p>

        <label className="mb-1 block text-xs font-medium text-slate-700" htmlFor="m-user" data-id="element-413" data-mp="2qv2ves9vngbd">বিপি/ইউজার আইডি</label>
        <div className="relative mb-3" data-id="element-414" data-mp="2vo5q53qe4vt5">
          <User className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-415" data-mp="2vp75vlicq6h7" />
          <Input id="m-user" value={userId} onChange={e => setUserId(e.target.value)} className="h-11 pl-9" data-id="element-416" data-mp="30ns5bips4m4l" />
        </div>
        <label className="mb-1 block text-xs font-medium text-slate-700" htmlFor="m-pass" data-id="element-417" data-mp="3ajveh8j1tl11">পাসওয়ার্ড</label>
        <div className="relative mb-2" data-id="element-418" data-mp="2kvg70hwb1nex">
          <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-419" data-mp="2kw98b3chvkpo" />
          <Input id="m-pass" type={show ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="h-11 pl-9 pr-10" data-id="element-420" data-mp="2fyg5mkaeh8u5" />
          <button type="button" onClick={() => setShow(!show)} aria-label="পাসওয়ার্ড দেখুন" className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-421" data-mp="2puj51idvatde">
            {show ? <EyeOff className="h-4 w-4" data-id="element-422" data-mp="33oahayizgrct" /> : <Eye className="h-4 w-4" data-id="element-423" data-mp="2ynw8he9k5ddq" />}
          </button>
        </div>
        {error && <p className="mb-2 text-xs text-red-600" data-id="element-424" data-mp="3dkdfxuemm7v0">{error}</p>}
        <button type="button" className="mb-4 text-xs font-medium text-navy-600" data-id="element-425" data-mp="3djvmf5jcm7qs">পাসওয়ার্ড ভুলে গেছেন?</button>

        <Button type="submit" disabled={loading} className="h-11 w-full text-[15px]" data-id="element-426" data-mp="38jhavdijgfo0">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" data-id="element-427" data-mp="1j8qcjjho4z30" /> : null}
          {loading ? 'যাচাই করা হচ্ছে…' : 'লগইন করুন'}
        </Button>
        <Button type="button" variant="outline" onClick={() => submit()} className="mt-2.5 h-11 w-full border-navy-200 text-navy-800" data-id="element-428" data-mp="3pv4nk3xrtt1c">
          <Fingerprint className="h-5 w-5" data-id="element-429" data-mp="3uso6hh5eytzm" />
          বায়োমেট্রিক লগইন
        </Button>

        <div className="mt-5 rounded-lg border border-navy-100 bg-navy-50 p-3" data-id="element-430" data-mp="3g41t3kzckcb1">
          <p className="mb-1.5 text-[10px] font-semibold uppercase tracking-wide text-navy-600" data-id="element-431" data-mp="3l3msfwifimoa">নমুনা ইউজার</p>
          <dl className="grid grid-cols-[64px_1fr] gap-y-1 text-xs" data-id="element-432" data-mp="373by2jhwupyd">
            <dt className="text-slate-500" data-id="element-433" data-mp="3b5qhb4phrrq6">ইউজার:</dt><dd className="font-medium text-navy-900" data-id="element-434" data-mp="3b6rqt4qv065s">এসআই মোঃ কামরুল হাসান</dd>
            <dt className="text-slate-500" data-id="element-435" data-mp="2x70klq6l3u2c">পদবি:</dt><dd className="font-medium text-navy-900" data-id="element-436" data-mp="2x81uhrbv6aih">সার্জেন্ট</dd>
            <dt className="text-slate-500" data-id="element-437" data-mp="326d35yqfaez4">বিভাগ:</dt><dd className="font-medium text-navy-900" data-id="element-438" data-mp="327eiwgidvpn6">ট্রাফিক-মিরপুর</dd>
          </dl>
        </div>
      </form>
    </div>;
}